import * as React from "react";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import OverlayTooltip from "app/common/components/overlayTooltip";
import OutlineButton from "app/common/components/featureButton/preset/outlineButton/index";
import CollectionTooltipContainer from "./collectionTooltip";

const styles = require("./collectionClip.scss");

interface IProps {
  postId: Vingle.Id;
  clipState: boolean;
  clipCount: number;
  width: number;
  height: number;
  onClick?: () => void;
}

const CollectionClipButton: React.FC<IProps> = ({
  postId,
  clipState,
  clipCount,
  width,
  height,
  onClick,
}) => {
  const [hoverState, setHoverState] = React.useState(false);
  const handleHover = React.useCallback(setHoverState, []);

  const baseIcon = clipState
    ? PACKS.ENGAGE.CLIP_ACTIVE
    : PACKS.ENGAGE.CLIP_NORMAL;
  const changeableIcon = hoverState ? PACKS.ENGAGE.CLIP_HOVER : baseIcon;

  return (
    <OverlayTooltip
      position="right-start"
      tooltipContent={<CollectionTooltipContainer postId={postId} />}
    >
      <OutlineButton
        width={width}
        height={height}
        onClick={onClick}
        onHover={handleHover}
        hoverColor="vingle-red"
      >
        <span className={styles.iconWrapper}>
          <IconWrapper
            tagName="span"
            icon={changeableIcon}
            className={styles.icon}
          />
        </span>

        {Boolean(clipCount) && (
          <span className={styles.engageCount}>
            <NumberFormatter num={clipCount} digits={0} />
          </span>
        )}
      </OutlineButton>
    </OverlayTooltip>
  );
};

export default CollectionClipButton;
